import clsx from 'clsx';
import {FC} from 'react';

import Icon, {Icons} from '~/common/Icon';

import s from '../styles.module.scss';

interface OvalLoaderIconProps {
  size: number;
  className?: string;
}

const OvalLoaderIcon: FC<OvalLoaderIconProps> = ({size, className}) => (
  <Icon
    name={Icons.hotLoader}
    width={size}
    height={size}
    className={clsx(s['spinner-icon'], className)}
  />
);

export default OvalLoaderIcon;
